import React from "react";

/*
 * Today's result box — compact, recreated to match reference image.
 * Numbers are dynamic; shows "Wait" when a result is not declared yet.
 */
export default function ResultBox({ result, declared, date }) {
  const fr = declared && result?.fr ? result.fr : "Wait";
  const sr = declared && result?.sr ? result.sr : "Wait";

  return (
    <div data-testid="today-result-box" className="mx-auto max-w-md px-3">
      <table className="w-full border-collapse text-center">
        <tbody>
          <tr>
            <td
              colSpan={2}
              className="border border-[#17b8a6] bg-[#ebedef] py-1 text-sm font-medium text-[#10161f] sm:text-base"
            >
              BHUTAN MORNING
            </td>
          </tr>
          <tr>
            <td className="w-1/2 border border-[#17b8a6] bg-[#17b8a6] py-1 text-xs font-semibold text-white sm:text-sm">
              F/R (10:30&nbsp;AM)
            </td>
            <td className="w-1/2 border border-[#17b8a6] bg-[#17b8a6] py-1 text-xs font-semibold text-white sm:text-sm">
              S/R (11:30&nbsp;AM)
            </td>
          </tr>
          <tr>
            <td
              data-testid="today-fr"
              className="border border-[#17b8a6] bg-white py-1 text-lg font-bold text-[#10161f] sm:text-2xl"
            >
              {fr}
            </td>
            <td
              data-testid="today-sr"
              className="border border-[#17b8a6] bg-white py-1 text-lg font-bold text-[#10161f] sm:text-2xl"
            >
              {sr}
            </td>
          </tr>
        </tbody>
      </table>

      {!declared && (
        <p
          data-testid="result-not-declared"
          className="mt-1.5 text-center text-xs text-slate-500"
        >
          Today's result ({date}) is not declared yet. Please check back after
          the draw time.
        </p>
      )}
    </div>
  );
}
